import {
  LinkLabelCategory,
  NodeCategory,
} from 'src/containers/ProjectDiagram/constants/categories';
import { NodeData } from 'src/containers/ProjectDiagram/types/model';
import { getModelConceptClassValue } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';

export const getMappingTargetIri = (
  targetKey: string,
  nodeDataArray: NodeData[]
) => {
  if (targetKey.startsWith(NodeCategory.MODEL_CONCEPT_CLASS)) {
    return getModelConceptClassValue(targetKey);
  }
  if (
    targetKey.startsWith(LinkLabelCategory.MODEL_CONCEPT_RELATIONSHIP_LABEL)
  ) {
    return (
      nodeDataArray.find((nodeData) => nodeData.key === targetKey)?.value ||
      null
    );
  }
  return null;
};
